import { useApiQuery } from "../infrastructure/hooks/useApiQuery";
import { endpointsMetadata } from "../infrastructure/routes/endpointsMetadata";
import { ISelectFieldModel } from "../components/forms/inputs/dropdown/models/selectFieldModel";
import { useAppContext } from "../../AppContext";

/**
 * Fetches the studio's active (non-deleted) pre-reservation forms as dropdown
 * options. Only runs when the studio has the feature enabled, so studios that
 * don't use forms make no extra request.
 */
export const usePreReservationFormOptions = () => {
  const { selectedStudio } = useAppContext();
  const usesPreReservationForms =
    selectedStudio?.usesPreReservationForms === true;

  const { data } = useApiQuery<ISelectFieldModel[]>({
    queryKey: [endpointsMetadata.preReservationForm.getActiveOptions],
    endpoint: endpointsMetadata.preReservationForm.getActiveOptions,
    enabled: usesPreReservationForms,
    globalIsLoading: false,
  });

  return {
    formOptions: data ?? [],
    usesPreReservationForms,
  };
};
